import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import MetricsBar from "./components/MetricsBar";
import CommandPalette from "./components/CommandPalette";
import Hero from "./components/Hero";
import About from "./components/About";
import Architecture from "./components/Architecture";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import GitHubRepos from "./components/GitHubRepos";
import ResumeSection from "./components/ResumeSection";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import LoadingScreen from "./components/LoadingScreen";
import AIAssistant from "./components/AIAssistant";
import { Toaster } from "./components/ui/sonner";

const Home = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 2700);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="App">
      {loading && <LoadingScreen />}
      <Navbar />
      <MetricsBar />
      <CommandPalette />
      <main className="pt-9">
        <Hero />
        <About />
        <Architecture />
        <Projects />
        <Skills />
        <Experience />
        <GitHubRepos />
        <ResumeSection />
        <Contact />
      </main>
      <Footer />
      <AIAssistant />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
